import type { JackpotRoundsPiles } from './modelTypes/jackpot';

// Default word piles per round for the "Jackpot van Las Vegas" game.
// Presets can override these by setting round1/round2/round3 on the preset.
// Icons are looked up by name in game-client's `wordIconData` as a fallback
// when no `icon` field is explicitly set on a card.
export const defaultRoundWordData: JackpotRoundsPiles = {
	1: {
		goodCards: [
			{ name: 'Creatief' },
			{ name: 'Empathisch' },
			{ name: 'Geduldig' },
			{ name: 'Flexibel' },
			{ name: 'Vastberaden' },
			{ name: 'Enthousiast' },
			{ name: 'Positief' },
			{ name: 'Betrouwbaar' },
			{ name: 'Leergierig' },
			{ name: 'Humoristisch' },
			{ name: 'Doelgericht' },
			{ name: 'Oplossingsgericht' },
			{ name: 'Integer' },
			{ name: 'Teamspeler' },
			{ name: 'Analytisch' },
			{ name: 'Stressbestendig' },
			{ name: 'Communicatief sterk' },
			{ name: 'Inspirerend' },
			{ name: 'Charismatisch' },
			{ name: 'Proactief' },
			{ name: 'Praktisch ingesteld' },
			{ name: 'Open-minded' },
			{ name: 'Efficiënt' },
			{ name: 'Assertief' },
			{ name: 'Perfectionistisch' },
			{ name: 'Nauwkeurig' },
			{ name: 'Innovatief' },
			{ name: 'Optimistisch' },
			{ name: 'Strategisch' },
			{ name: 'Gedreven' },
			{ name: 'Behulpzaam' },
			{ name: 'Georganiseerd' },
			{ name: 'Avontuurlijk' },
			{ name: 'Ondernemend' },
			{ name: 'Zelfverzekerd' },
			{ name: 'Toegankelijk' },
			{ name: 'Betrokken' },
			{ name: 'Resultaatgericht' },
			{ name: 'Veerkrachtig' },
		],
		badCards: [
			{ name: 'Geef snel op' },
			{ name: 'Onverschillig' },
			{ name: 'Weinig veerkracht' },
			{ name: 'Moeilijk benaderbaar' },
			{ name: 'Angst voor het onbekende' },
			{ name: 'Ongeorganiseerd' },
			{ name: 'Ongevoelig' },
			{ name: 'Onzeker' },
			{ name: 'Chaotisch' },
			{ name: 'Gebrek aan motivatie' },
			{ name: 'Niet nauwkeurig' },
			{ name: 'Niet durven veranderen' },
			{ name: 'Geen visie' },
			{ name: 'Niet inspirerend' },
			{ name: 'Zwakke communicatie' },
			{ name: 'Snel gestrest' },
			{ name: 'Moeite met loslaten' },
			{ name: 'Weinig analytisch vermogen' },
			{ name: 'Te afhankelijk van anderen' },
			{ name: 'Doelloos' },
			{ name: 'Moeite met samenwerken' },
			{ name: 'Niet flexibel' },
			{ name: 'Te negatief ingesteld' },
			{ name: 'Niet creatief genoeg' },
			{ name: 'Te weinig ambitie' },
			{ name: 'Verlies van richting' },
			{ name: 'Besluiteloos' },
			{ name: 'Slordig' },
			{ name: 'Riscomijdend' },
			{ name: 'Niet goed luisteren' },
			{ name: 'Gebrek aan grenzen' },
			{ name: 'Perfectionisme' },
			{ name: 'Financiële onzekerheid' },
			{ name: 'Wispelturig' },
			{ name: 'Slechte timing' },
			{ name: 'Vertrouwensproblemen' },
			{ name: 'Chaos in planning' },
			{ name: 'Slordig in details' },
			{ name: 'Zich onbegrepen voelen' },
			{ name: 'Verlies van energie' },
			{ name: 'Onrealistische verwachtingen' },
			{ name: 'Onderwaardering van jezelf' },
			{ name: 'Passief' },
			{ name: 'Weinig waardering voor details' },
		],
		desireCards: [
			{ name: 'Nieuwe ideeën bedenken' },
			{ name: 'Anderen echt begrijpen' },
			{ name: 'Mijzelf beter aanpassen' },
			{ name: 'Meer passie uitstralen' },
			{ name: 'Optimistisch zijn' },
			{ name: 'Focus op groeien' },
			{ name: 'Vanuit mijn eigen kracht presteren' },
			{ name: 'Focus op resultaat' },
			{ name: 'Problemen creatief oplossen' },
			{ name: 'Transparant zijn' },
			{ name: 'Anderen oprecht steunen' },
			{ name: 'De focus leggen op samen sterker' },
			{ name: 'Patronen wat scherper zien' },
			{ name: 'Kalm blijven onder grote druk' },
			{ name: 'Mezelf duidelijk en krachtig uiten' },
			{ name: 'Altijd een stap vooruit zetten' },
			{ name: 'Meer lachen en verbinden' },
			{ name: 'Vastberaden zijn op mijn doel' },
			{ name: 'Realistische oplossingen vinden' },
			{ name: 'Groots durven dromen' },
			{ name: 'Nieuwsgierig zijn' },
			{ name: 'Zaken zonder oordeel bekijken' },
			{ name: 'Altijd volledig betrokken zijn' },
			{ name: 'Snel en effectief handelen' },
			{ name: 'Duidelijk grenzen aangeven' },
			{ name: 'Altijd de angst overwinnen' },
			{ name: 'Streven naar excellentie' },
			{ name: 'Op elk detail letten' },
			{ name: 'Altijd vooruit denken' },
			{ name: 'Altijd positief blijven' },
			{ name: 'Eerst denken, dan handelen' },
			{ name: 'Met passie doelen behalen' },
			{ name: 'Graag anderen ondersteunen' },
			{ name: 'Iedereen waardevol vinden' },
			{ name: 'Vaker orde in de chaos creëren' },
			{ name: 'Kansen altijd benutten' },
			{ name: 'Vaker lachen' },
			{ name: 'Anderen helpen richting te geven' },
			{ name: 'Geloven in mezelf' },
			{ name: 'Warm en benaderbaar zijn' },
			{ name: 'Altijd actief meedoen' },
			{ name: 'Trouw blijven aan mijn waarden' },
			{ name: 'Overal op zoek gaan naar verbinding' },
			{ name: 'Zorgen voor plezier' },
			{ name: 'Iedereen mee laten tellen' },
		],
	},
	2: {
		goodCards: [
			{ name: 'Samenwerking' },
			{ name: 'Communicatie' },
			{ name: 'Vertrouwen' },
			{ name: 'Respect' },
			{ name: 'Duidelijke doelen' },
			{ name: 'Creativiteit' },
			{ name: 'Motivatie' },
			{ name: 'Openheid' },
			{ name: 'Probleemoplossend vermogen' },
			{ name: 'Efficiëntie' },
			{ name: 'Verantwoordelijkheid nemen' },
			{ name: 'Flexibiliteit' },
			{ name: 'Innovatie' },
			{ name: 'Delen van kennis' },
			{ name: 'Ondersteuning' },
			{ name: 'Luisteren' },
			{ name: 'Enthousiasme' },
			{ name: 'Effectieve vergaderingen' },
			{ name: 'Rollen duidelijk verdelen' },
			{ name: 'Positieve feedback' },
			{ name: 'Diversiteit' },
			{ name: 'Conflictbeheersing' },
			{ name: 'Tijdmanagement' },
			{ name: 'Resultaatgerichtheid' },
			{ name: 'Betrokkenheid' },
			{ name: 'Werkplezier' },
			{ name: 'Balans tussen werk en ontspanning' },
			{ name: 'Initiatief nemen' },
			{ name: 'Continu leren' },
			{ name: 'Toewijding' },
			{ name: 'Loyaliteit' },
			{ name: 'Humor' },
			{ name: 'Empathie' },
			{ name: 'Heldere verwachtingen' },
			{ name: 'Respect voor deadlines' },
			{ name: 'Inspiratie delen' },
			{ name: 'Eerlijke verdeling van taken' },
			{ name: 'Goede besluitvorming' },
			{ name: 'Stimuleren van persoonlijke groei' },
			{ name: 'Positieve sfeer' },
			{ name: 'Doelbewuste planning' },
			{ name: 'Omgaan met verandering' },
			{ name: 'Samen vieren van successen' },
			{ name: 'Waardering tonen' },
			{ name: 'Duurzame samenwerking' },
		],
		badCards: [
			{ name: 'Samenwerking' },
			{ name: 'Communicatie' },
			{ name: 'Vertrouwen' },
			{ name: 'Respect' },
			{ name: 'Duidelijke doelen' },
			{ name: 'Creativiteit' },
			{ name: 'Motivatie' },
			{ name: 'Openheid' },
			{ name: 'Probleemoplossend vermogen' },
			{ name: 'Efficiëntie' },
			{ name: 'Verantwoordelijkheid nemen' },
			{ name: 'Flexibiliteit' },
			{ name: 'Innovatie' },
			{ name: 'Delen van kennis' },
			{ name: 'Ondersteuning' },
			{ name: 'Luisteren' },
			{ name: 'Enthousiasme' },
			{ name: 'Effectieve vergaderingen' },
			{ name: 'Rollen duidelijk verdelen' },
			{ name: 'Positieve feedback' },
			{ name: 'Diversiteit' },
			{ name: 'Conflictbeheersing' },
			{ name: 'Tijdmanagement' },
			{ name: 'Resultaatgerichtheid' },
			{ name: 'Betrokkenheid' },
			{ name: 'Werkplezier' },
			{ name: 'Balans tussen werk en ontspanning' },
			{ name: 'Initiatief nemen' },
			{ name: 'Continu leren' },
			{ name: 'Toewijding' },
			{ name: 'Loyaliteit' },
			{ name: 'Humor' },
			{ name: 'Empathie' },
			{ name: 'Heldere verwachtingen' },
			{ name: 'Respect voor deadlines' },
			{ name: 'Inspiratie delen' },
			{ name: 'Eerlijke verdeling van taken' },
			{ name: 'Goede besluitvorming' },
			{ name: 'Stimuleren van persoonlijke groei' },
			{ name: 'Positieve sfeer' },
			{ name: 'Doelbewuste planning' },
			{ name: 'Omgaan met verandering' },
			{ name: 'Samen vieren van successen' },
			{ name: 'Waardering tonen' },
			{ name: 'Duurzame samenwerking' },
		],
		desireCards: [
			{ name: 'Communicatie verbeteren' },
			{ name: 'Vertrouwen versterken' },
			{ name: 'Misverstanden voorkomen' },
			{ name: 'Betrokkenheid vergroten' },
			{ name: 'Conflicten als groeikans zien' },
			{ name: 'Doelen beter afstemmen' },
			{ name: 'Productievere vergaderingen' },
			{ name: 'Eerlijkere werkverdeling' },
			{ name: 'Realistischere verwachtingen' },
			{ name: 'Positievere houdingen' },
			{ name: 'Constructievere feedback' },
			{ name: 'Respect laten groeien' },
			{ name: 'Middelen beter benutten' },
			{ name: 'Veranderingen beter begeleiden' },
			{ name: 'Professioneel gedrag stimuleren' },
			{ name: 'Minder micromanagement' },
			{ name: 'Motiverende beloningen' },
			{ name: 'Toegankelijkere ondersteuning' },
			{ name: 'Gezondere competitie' },
			{ name: 'Meer transparantie' },
			{ name: 'Conflicten constructief oplossen' },
			{ name: 'Efficiënter tijdbeheer' },
			{ name: 'Duidelijke rolverdeling' },
			{ name: 'Motivatie aanwakkeren' },
			{ name: 'Strakkere planning' },
			{ name: 'Overbelasting voorkomen' },
			{ name: 'Creativiteit stimuleren' },
			{ name: 'Verantwoordelijkheid delen' },
			{ name: 'Samenwerking versterken' },
			{ name: 'Meningen beter horen' },
			{ name: 'Gelijkwaardige behandeling' },
			{ name: 'Gebalanceerde werkdruk' },
			{ name: 'Gestroomlijnde kennisdeling' },
			{ name: 'Fouten als leermomenten' },
			{ name: 'Flexibiliteit vergroten' },
			{ name: 'Eenvoudigere processen' },
			{ name: 'Duidelijke visie communiceren' },
			{ name: 'Scherpere focus' },
			{ name: 'Soepelere veranderingen' },
			{ name: 'Effectievere besluitvorming' },
			{ name: 'Vaker waardering tonen' },
			{ name: 'Heldere communicatiekanalen' },
			{ name: 'Empathie vergroten' },
			{ name: 'Persoonlijke groei stimuleren' },
			{ name: 'Sterkere teamdynamiek' },
		],
	},
	3: {
		goodCards: [
			{ name: 'Goede communicatie' },
			{ name: 'Vertrouwen hebben in elkaar' },
			{ name: 'Weten wat je van elkaar verwacht' },
			{ name: 'Iedereen doet mee' },
			{ name: 'Snelle en nuttige vergaderingen' },
			{ name: 'Samen problemen oplossen' },
			{ name: 'Heldere doelen maken' },
			{ name: 'Positieve complimenten geven' },
			{ name: 'Nieuwe ideeën delen' },
			{ name: 'Respect hebben voor elkaar' },
			{ name: 'Taken eerlijk verdelen' },
			{ name: 'Iedereen wordt gelijk behandeld' },
			{ name: 'Afspraak is afspraak' },
			{ name: 'Elkaar helpen waar je goed in bent' },
			{ name: 'Flexibel blijven' },
			{ name: 'Iedereen doet zijn best' },
			{ name: 'Successen samen vieren' },
			{ name: 'Problemen rustig oplossen' },
			{ name: 'Samen iets nieuws bedenken' },
			{ name: 'Tijd goed plannen' },
			{ name: 'Veranderingen samen aanpakken' },
			{ name: 'Ideeën uitwisselen' },
			{ name: 'Groeien in wat je doet' },
			{ name: 'Slimme beslissingen nemen' },
			{ name: 'Balans tussen werk en rust' },
			{ name: 'Samen kansen zien' },
			{ name: 'Elkaar aanmoedigen' },
			{ name: 'Luisteren naar elkaar' },
			{ name: 'Eerlijk zeggen wat er speelt' },
			{ name: 'Technologie gebruiken om beter te werken' },
			{ name: 'Grenzen respecteren' },
			{ name: 'Netjes en professioneel werken' },
			{ name: 'Duidelijk weten wie wat doet' },
			{ name: 'Leren van fouten' },
			{ name: 'Samen kijken wat beter kan' },
			{ name: 'Goed samenwerken als een team' },
			{ name: 'Gericht blijven op het doel' },
			{ name: 'Ruimte geven voor creativiteit' },
			{ name: 'Elkaar uitdagen om beter te worden' },
			{ name: 'Feedback geven die helpt' },
			{ name: 'Risico’s bespreken en aanpakken' },
			{ name: 'Kennis en tips delen' },
			{ name: 'Afspraken nakomen' },
			{ name: 'Iedereen erbij betrekken' },
			{ name: 'Realistisch plannen' },
		],
		badCards: [
			{ name: 'Goede communicatie' },
			{ name: 'Vertrouwen hebben in elkaar' },
			{ name: 'Weten wat je van elkaar verwacht' },
			{ name: 'Iedereen doet mee' },
			{ name: 'Snelle en nuttige vergaderingen' },
			{ name: 'Samen problemen oplossen' },
			{ name: 'Heldere doelen maken' },
			{ name: 'Positieve complimenten geven' },
			{ name: 'Nieuwe ideeën delen' },
			{ name: 'Respect hebben voor elkaar' },
			{ name: 'Taken eerlijk verdelen' },
			{ name: 'Iedereen wordt gelijk behandeld' },
			{ name: 'Afspraak is afspraak' },
			{ name: 'Elkaar helpen waar je goed in bent' },
			{ name: 'Flexibel blijven' },
			{ name: 'Iedereen doet zijn best' },
			{ name: 'Successen samen vieren' },
			{ name: 'Problemen rustig oplossen' },
			{ name: 'Samen iets nieuws bedenken' },
			{ name: 'Tijd goed plannen' },
			{ name: 'Veranderingen samen aanpakken' },
			{ name: 'Ideeën uitwisselen' },
			{ name: 'Groeien in wat je doet' },
			{ name: 'Slimme beslissingen nemen' },
			{ name: 'Balans tussen werk en rust' },
			{ name: 'Samen kansen zien' },
			{ name: 'Elkaar aanmoedigen' },
			{ name: 'Luisteren naar elkaar' },
			{ name: 'Eerlijk zeggen wat er speelt' },
			{ name: 'Technologie gebruiken om beter te werken' },
			{ name: 'Grenzen respecteren' },
			{ name: 'Netjes en professioneel werken' },
			{ name: 'Duidelijk weten wie wat doet' },
			{ name: 'Leren van fouten' },
			{ name: 'Samen kijken wat beter kan' },
			{ name: 'Goed samenwerken als een team' },
			{ name: 'Gericht blijven op het doel' },
			{ name: 'Ruimte geven voor creativiteit' },
			{ name: 'Elkaar uitdagen om beter te worden' },
			{ name: 'Feedback geven die helpt' },
			{ name: 'Risico’s bespreken en aanpakken' },
			{ name: 'Kennis en tips delen' },
			{ name: 'Afspraken nakomen' },
			{ name: 'Iedereen erbij betrekken' },
			{ name: 'Realistisch plannen' },
		],
		desireCards: [
			{ name: 'Communicatie verbeteren' },
			{ name: 'Vertrouwen versterken' },
			{ name: 'Misverstanden voorkomen' },
			{ name: 'Betrokkenheid vergroten' },
			{ name: 'Conflicten als groeikans zien' },
			{ name: 'Doelen beter afstemmen' },
			{ name: 'Productievere vergaderingen' },
			{ name: 'Eerlijkere werkverdeling' },
			{ name: 'Realistischere verwachtingen' },
			{ name: 'Positievere houdingen' },
			{ name: 'Constructievere feedback' },
			{ name: 'Respect laten groeien' },
			{ name: 'Middelen beter benutten' },
			{ name: 'Veranderingen beter begeleiden' },
			{ name: 'Professioneel gedrag stimuleren' },
			{ name: 'Minder micromanagement' },
			{ name: 'Motiverende beloningen' },
			{ name: 'Toegankelijkere ondersteuning' },
			{ name: 'Gezondere competitie' },
			{ name: 'Meer transparantie' },
			{ name: 'Conflicten constructief oplossen' },
			{ name: 'Efficiënter tijdbeheer' },
			{ name: 'Duidelijke rolverdeling' },
			{ name: 'Motivatie aanwakkeren' },
			{ name: 'Strakkere planning' },
			{ name: 'Overbelasting voorkomen' },
			{ name: 'Creativiteit stimuleren' },
			{ name: 'Verantwoordelijkheid delen' },
			{ name: 'Samenwerking versterken' },
			{ name: 'Meningen beter horen' },
			{ name: 'Gelijkwaardige behandeling' },
			{ name: 'Gebalanceerde werkdruk' },
			{ name: 'Gestroomlijnde kennisdeling' },
			{ name: 'Fouten als leermomenten' },
			{ name: 'Flexibiliteit vergroten' },
			{ name: 'Eenvoudigere processen' },
			{ name: 'Duidelijke visie communiceren' },
			{ name: 'Scherpere focus' },
			{ name: 'Soepelere veranderingen' },
			{ name: 'Effectievere besluitvorming' },
			{ name: 'Vaker waardering tonen' },
			{ name: 'Heldere communicatiekanalen' },
			{ name: 'Empathie vergroten' },
			{ name: 'Persoonlijke groei stimuleren' },
			{ name: 'Sterkere teamdynamiek' },
		],
	},
};
